import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { API_URL, LOCATION_ID } from "..";

const PurchaseBillListLayer = ({ billsData = [] }) => {
  const tableRef = useRef(null);
  const history = useNavigate();

  // States for modal
  const [selectedBill, setSelectedBill] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ show: false, type: "", text: "" });
  const [accounts, setAccounts] = useState([]);
const [selectedAccount, setSelectedAccount] = useState(null);
const [accountBalance, setAccountBalance] = useState(0);
const [paymentMethod, setPaymentMethod] = useState("");


  // Delete Bill
  const locationId =  localStorage.getItem('locationID')
  const handleDelete = async (id) => {
    // if (!window.confirm("Are you sure you want to delete this Bill?")) return;
    try {
      const res = await fetch(`${API_URL}/api/purchase-bills/${id}?locationId=${locationId}`, { method: "DELETE" });
      if (res.ok) window.location.reload();
    } catch (err) {
      alert("Error deleting bill: " + err.message);
    }
  };

  const fetchAccounts = async () => {
  try {
    const res = await fetch(`${API_URL}/api/accounts/location/${LOCATION_ID}`);
    const data = await res.json();
    setAccounts(data.accounts || []);
  } catch (err) {
  }
};


  // Open Modal (no window.bootstrap)
  const handleMakePayment = (id) => {
    const bill = billsData.find((b) => b.id === id);
    setSelectedBill(bill);

    // Click hidden trigger to open modal
    const trigger = document.getElementById("paymentModalTrigger");
    if (trigger) trigger.click();
  };

  // Submit Payment
  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage({ show: false, type: "", text: "" });

    const form = e.target;
const formData = {
  supplier_id: selectedBill?.supplier_id,
  bill_id: selectedBill?.id,
  payment_date: form.payment_date.value,
  payment_method: paymentMethod,
  amount: parseFloat(form.amount.value),
  locationId : locationId,
  remarks: form.remarks.value,
  account_id: selectedAccount?.id || null,   // 👈 added
};


    try {
      const res = await fetch(`${API_URL}/api/purchase-payments`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();

      if (res.ok) {
        window.location.reload();
        setMessage({ show: true, type: "success", text: "Payment added successfully!" });
        // Close modal after short delay
        setTimeout(() => {
          document.getElementById("closePaymentModalBtn")?.click();
        }, 1000);
      } else {
        throw new Error(data.message || "Failed to make payment");
      }
    } catch (err) {
      setMessage({ show: true, type: "danger", text: err.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Init DataTable
  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#billTable")) {
      $("#billTable").DataTable().destroy(true);
    }

   tableRef.current = $("#billTable").DataTable({
  data: billsData,
  responsive: true,
  pageLength: 10,
  order: [[0, 'desc']],
  columns: [
    {
      data: null,
      title: "#",
      render: (data, type, row, meta) => {
        return meta.settings.fnRecordsDisplay() - meta.row - meta.settings._iDisplayStart;
      }
    },
   {
  data: "bill_number",
  title: "Bill Number",
  render: (bill_number, type, row) => {
    return `<a href="/view-bill/${row.id}" class="text-primary">${bill_number}</a>`;
  }
},
    { data: "date", title: "Date" },
    {
      data: "Supplier",
      title: "Supplier",
      render: (s) => s?.name || "N/A",
    },
    {
      data: "total_amount",
      title: "Total",
      render: (data) => `Rs. ${parseFloat(data).toLocaleString()}`,
    },
    { data: "paid_amount", title: "Paid" },
    { data: "due_amount", title: "Due" },
    { data: "status", title: "Status" },
    {
      data: null,
      title: "Actions",
      render: (data, type, row) => `
        <div class="dropdown">
          <button class="dropdown-toggle" data-bs-toggle="dropdown">
            <i class="ph ph-list"></i>
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item view-btn" data-id="${row.id}">
              <i class="ph ph-eye"></i> View</a></li>
            <li><a class="dropdown-item pay-btn" data-id="${row.id}">
              <i class="ph ph-wallet"></i> Make Payment</a></li>
           
          </ul>
        </div>
      `,
    },
  ],
});


    // Event Bindings
    $("#billTable tbody").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      history(`/view-bill/${id}`);
    });

    // $("#billTable tbody").on("click", ".delete-btn", function () {
    //   handleDelete($(this).data("id"));
    // });

    $("#billTable tbody").on("click", ".pay-btn", function () {
      handleMakePayment($(this).data("id"));
    });

    return () => {
      if ($.fn.DataTable.isDataTable("#billTable")) $("#billTable").DataTable().destroy(true);
    };
  }, [billsData]);

  return (
    <>
      {/* Hidden modal trigger (Bootstrap data API) */}
      <button
        id="paymentModalTrigger"
        type="button"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#paymentModal"
      ></button>

      {/* Table */}
      <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Purchase Bills</h5>
            <div className="col-md-6 text-end">
              <Link className="btn btn-info" to="/add-bill">
                Add New
              </Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="billTable"></table>
        </div>
      </div>

      {/* 💳 Make Payment Modal */}
      <div
        className="modal fade"
        id="paymentModal"
        tabIndex="-1"
        aria-labelledby="paymentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handlePaymentSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="paymentModalLabel">
                  Make Payment
                </h5>
                <button
                  type="button"
                  id="closePaymentModalBtn"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {message.show && (
                  <div className={`alert alert-${message.type}`}>{message.text}</div>
                )}

                {selectedBill ? (
                  <>
                    <div className="mb-3">
                      <label className="form-label">Supplier</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedBill.Supplier?.name || "N/A"}
                        readOnly
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Bill Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedBill.bill_number}
                        readOnly
                      />
                    </div>

                    <div className="mb-3 d-flex gap-2">
                      <div className="w-50">
                        <label className="form-label">Total</label>
                        <input
                          type="text"
                          className="form-control"
                          value={`Rs. ${selectedBill.total_amount}`}
                          readOnly
                        />
                      </div>
                      <div className="w-50">
                        <label className="form-label">Due</label>
                        <input
                          type="text"
                          className="form-control"
                          value={`Rs. ${selectedBill.due_amount}`}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Payment Method</label>
                    <select
  name="payment_method"
  className="form-select"
  required
  value={paymentMethod}
  onChange={(e) => {
    const method = e.target.value;
    setPaymentMethod(method);

    if (method === "Bank") {
      fetchAccounts();
    } else {
      setSelectedAccount(null);
      setAccountBalance(0);
    }
  }}
>
  <option value="">Select Method</option>
  <option value="Cash">Cash</option>
  <option value="Bank">Bank</option>
  <option value="Cheque">Cheque</option>
  <option value="Other">Other</option>
</select>

                    </div>

                    {paymentMethod === "Bank" && (
  <div className="mb-3">
    <label className="form-label">Select Bank Account</label>
    <select
      className="form-select"
      required
      onChange={(e) => {
        const acc = accounts.find(a => a.id == e.target.value);
        setSelectedAccount(acc);
        setAccountBalance(acc?.balance || 0);
      }}
    >
      <option value="">Select Account</option>

      {accounts.map((acc) => (
        <option key={acc.id} value={acc.id}>
          {acc.type.toUpperCase()} — {acc.accountTitle} ({acc.accountNo})
        </option>
      ))}

    </select>

    {selectedAccount && (
      <small className="text-success">
        💰 Available Balance: <b>Rs. {accountBalance.toLocaleString()}</b>
      </small>
    )}
  </div>
)}


                    <div className="mb-3">
                      <label className="form-label">Payment Date</label>
                      <input
                        type="date"
                        name="payment_date"
                        className="form-control"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Amount</label>
                  <input
  type="number"
  name="amount"
  className="form-control"
  placeholder="Enter amount"
  required
  max={paymentMethod === "Bank" ? accountBalance : selectedBill?.due_amount}
  onChange={(e) => {
    const value = parseFloat(e.target.value);
    if (paymentMethod === "Bank" && value > accountBalance) {
      e.target.value = accountBalance;
      alert("Amount cannot exceed account balance!");
    }
  }}
/>

                    </div>

                    <div className="mb-3">
                      <label className="form-label">Remarks</label>
                      <textarea
                        name="remarks"
                        className="form-control"
                        rows="2"
                        placeholder="Optional remarks..."
                      ></textarea>
                    </div>
                  </>
                ) : (
                  <p>Loading bill info...</p>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? "Processing..." : "Make Payment"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseBillListLayer;
